import { Box, CardMedia } from '@mui/material';
import { color } from '@/colors';
import { useIsHovered } from '@/hooks/useIsHovered';
import type { ReactNode } from 'react';

interface WorkflowCardDisplayProps {
  poster?: string;
  hoverOverlay?: ReactNode;
  forceShowOverlay?: boolean;
}

export default function WorkflowCardDisplay({ poster, hoverOverlay, forceShowOverlay }: WorkflowCardDisplayProps) {
  const { isHovered, ...hoveredProps } = useIsHovered();

  return (
    <>
      <Box
        {...hoveredProps}
        sx={{
          overflow: 'hidden',
          border: '1px solid',
          borderRadius: 2,
          borderColor: isHovered ? color.White08_T : color.Dark_Grey,
          height: 240,
          position: 'relative',
        }}
      >
        <CardMedia
          component="img"
          height="100%"
          image={poster || '/workflow-default-cover.png'}
          alt="workflow poster"
        />
        {isHovered && !hoverOverlay && (
          <Box sx={{ position: 'absolute', inset: 0, backgroundColor: color.White16_T, pointerEvents: 'none' }} />
        )}
        {(isHovered || forceShowOverlay) && hoverOverlay}
      </Box>
    </>
  );
}
